import { useState } from 'react'
import PlayerAvatar from './PlayerAvatar';
import HealthBar from "./HealthBar";
import store, { RootState } from '../store';
import { useAppSelector } from '../redux'
import { gameActions } from '../Game/gameSlice'
import { GamePlayState } from "../Enums/GameEnums";
import ImageAsset from '../Components/ImageAsset';
import { SpriteGenderNames } from '../Enums/NameEnums';
import './Game.scss';

function PlayerArea() {
    const CHIPS = [1, 5, 10]
    const [chipIndex, setChipIndex] = useState(1)
    const [selectedChip, setSelectedChip] = useState(1)
    const gameState = useAppSelector((state: RootState) => state.game)
    const healthPotionCount = gameState.player?.healthPotionCount ?? 0
    const gamePlayState = gameState.gamePlayState
    const player = gameState.player
    const balance = gameState.balance
    const playerTitle = gameState.player.gender === SpriteGenderNames.M ? 'Lord ' : 'Lady ';

    function handleDrinkPotion() {
        if (isDrinkHealthDisabled) {
            return;
        }

        store.dispatch(gameActions.drinkHealingPotion());
    }

    const isDrinkHealthDisabled = gamePlayState === GamePlayState.PLAYER_CARD_REVEAL ||
        gamePlayState === GamePlayState.PLAYER_ACTION ||
        gamePlayState === GamePlayState.DEALER_CARD_REVEAL ||
        healthPotionCount === 0

    const bet = gameState.bet

    function handleBetPlus() {
        const audio = new Audio('BlackJack RPG_Gen Btn SFX_20.10.2023.mp3');
        audio.play();
        store.dispatch(gameActions.increaseBet(selectedChip));
    }

    function handleBetMinus() {
        const audio = new Audio('BlackJack RPG_Gen Btn SFX_20.10.2023.mp3');
        audio.play();
        store.dispatch(gameActions.reduceBet(selectedChip));
    }

    function handleShaffleChipSelection() {
        const audio = new Audio('BlackJack RPG_Gen Btn SFX_20.10.2023.mp3');
        audio.play();
        setChipIndex((chipIndex + 1) % CHIPS.length)
        setSelectedChip(CHIPS[chipIndex])
    }

    return (
        <div className="player-area">
            <div className="player-area_avatar_container">
                <PlayerAvatar />
                <div className="player-area_name">{playerTitle} {player.name}</div>
                <div className="player-area_class_and_Level"> Level {player.maxLevelReached} {player.className} </div>
                <div className="player-area_health_bar_container">
                    <HealthBar type="player" currentHP={player.attributes.currentHp} maxHP={player.attributes.maxHp} />
                </div>
            </div>

            <div className='player-area_stats_container'>
                <div className='player-area_stats'>
                    <div className="attributes">
                        <div>
                            <span className='attr-title'>Att: </span>
                            <span className='attr-value'>{player.attributes.att}</span>
                        </div>
                        <div>
                            <span className='attr-title'>Def: </span>
                            <span className='attr-value'>{player.attributes.def}</span>
                        </div>
                        <div>
                            <span className='attr-title'>Prc: </span>
                            <span className='attr-value'>{player.attributes.pierce}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className='player-area_bet_container'>
                <div>
                    <button disabled={gamePlayState !== GamePlayState.BETTING} onClick={handleBetMinus}>-</button>
                    {/* <div className="chip-container">
                            <ImageAsset name="chip.png" multiplier={2} />
                            <div className="number-overlay" onClick={handleShaffleChipSelection} >{selectedChip}</div>
                        </div> */}
                    <button disabled={gamePlayState !== GamePlayState.BETTING} onClick={handleShaffleChipSelection}>{selectedChip}</button>
                    <button disabled={gamePlayState !== GamePlayState.BETTING} onClick={handleBetPlus}>+</button>
                    <p>Bet: {bet}</p>
                </div>
            </div>

            <div className={`player-area_potion ${isDrinkHealthDisabled ? 'disabled' : ''}`} onClick={handleDrinkPotion}>
                <ImageAsset name="potion.gif" />
                <div className='potion-counter'>x{healthPotionCount}</div>
            </div>

            <div className='player-area_balance'>
                <div>Balance: ${balance}</div>
            </div>
        </div>
    );
}

export default PlayerArea;
